import axios from "axios";
const CaritraWidgetApi = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL,
});

CaritraWidgetApi.interceptors.response.use(
    response => response?response.data:{error:true, errorMessage:"Unkown Internal Error"},
    error => error&&error.response?error.response.data:{error:true, errorMessage:"Unkown Internal Error"}
);


export default CaritraWidgetApi;